import React from "react";
import { IProps } from "./types";
import { FormElement, Label } from "../../../../../components/Form";
import { useIntl } from "react-intl";

const DisplayData = ({ label, value }: IProps) => {
    const { formatMessage } = useIntl();
    if (value.length === 0) return null;
    return (
        <FormElement>
            <Label>{formatMessage(label)}</Label>
            <div>{value.map(v => formatMessage(v)).join(", ")}</div>
        </FormElement>
    );
};

export default DisplayData;
